import { render, staticRenderFns } from "./BlogHandpick.vue?vue&type=template&id=e1bc08ae&scoped=true"
import script from "./BlogHandpick.vue?vue&type=script&lang=js"
export * from "./BlogHandpick.vue?vue&type=script&lang=js"
import style0 from "./BlogHandpick.vue?vue&type=style&index=0&id=e1bc08ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bc08ae",
  null
  
)

export default component.exports